export enum PaginationType {
  Base = 'base',
  Dot = 'dot',
  PillSm = 'pill-sm',
  PillRg = 'pill-lg',
}

export const PaginationAutoplayTime = 10000;
